<template>
  <div>
    <div class="search_content_textBox">
      <div class="search_content_textBox_top">검색결과</div>
    </div>
    <div class="empty_list">
      <div class="empty_img"></div>
      <div class="empty_text">검색어를 입력해주세요.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoardEmptySearchDefaultLayout",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>